/**
 * Created by andrewstirling on 21/12/16.
 */

import React, { Component } from 'react';

export default class CustomerIntegrations extends Component {
    render() {
        if( !this.props.customer || !this.props.customer.integrations || !Object.keys(this.props.customer.integrations).length ) {
            return null;
        }
        var integrations = [];
        for( var i = 0; i < Object.keys(this.props.customer.integrations).length; i++ ) {
            var key = Object.keys(this.props.customer.integrations)[i];
            integrations.push(this.generateIntegrationElement(key, this.props.customer.integrations[key]));
        }
        return (
            <div>
                <label className="box-label">Third-party integrations</label>
                <div className="each-customer-info">
                    <div className="col-lg-10 col-sm-12 personal-info">
                        {integrations}
                    </div>
                </div>
            </div>
        );//return
    }//render

    generateIntegrationElement = (name, integration) => {
        switch(name) {
            case "salesforceMC":
                console.log(integration.activated);
                return (
                    <div key={name}><span>Salesforce Marketing Cloud</span><input id="salesforceToggle" className="cmn-toggle cmn-toggle-round" type="checkbox" onChange={this.props.toggleSalesforceActive} checked={integration.activated} />
                        <label htmlFor="salesforceToggle"></label></div>
                );
        }
        return null;
    }//generateIntegrationElement
}//CustomerInformation